import React, { useEffect } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';

function MyApp({ message, variant }) {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (message) {
      enqueueSnackbar(message, { 
        variant, 
        hideIconVariant: true,
        autoHideDuration: 6000 // Auto hide after 6 seconds
      });
    }
  }, [message, variant, enqueueSnackbar]);

  return null;
}

export default function CustomSnackbar({ message, variant }) {
  return (
    <SnackbarProvider 
      maxSnack={3} 
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }} 
      style={{ top: '70px' }}
      autoHideDuration={6000}
    >
      <MyApp message={message} variant={variant} />
    </SnackbarProvider>
  );
}
